export enum DisplayType {
    LIST = 1,
    TREE,
  }